// dell when impliment new DataGrit in project
export const listNumberRowTable = [25, 50, 100, 250];

// for new list Number Row Table
export const defaultNumOfRowsOptions = [
  { name: 25, selected: true },
  { name: 50, selected: false },
  { name: 100, selected: false },
  { name: 250, selected: false }
];

const defaultRowsInTable = 25;

export const initialTableShow = {
  direction: -1,
  currentPage: 1,
  itemsPerPage: defaultRowsInTable
};

// TODO Request from server currrent networkVersion
export const lastVersionNetwork = '3.8.0';
export const oldNetworkVersion = '0.8.0';
